export class DialogModelPrintBillWarning {
    constructor(
      public data: any
    ) {}
  }
  